import '../assets/NcCounterBubble-DWgyYB0d.css';
import { getCanonicalLocale } from "@nextcloud/l10n";
import { createElementBlock, openBlock, normalizeClass, toDisplayString } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcCounterBubble",
  props: {
    type: {
      type: String,
      default: "",
      validator(value) {
        return ["highlighted", "outlined", ""].includes(value);
      }
    },
    /**
     * Specifies whether the component is used within a component that is
     * active and therefore has a primary background. Inverts the color of
     * this component when that is the case.
     */
    active: {
      type: Boolean,
      default: false
    },
    /**
     * The count to display in the counter bubble.
     */
    count: {
      type: Number,
      required: true
    },
    /**
     * Disables humanization to display count as it is.
     */
    raw: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    counterClassObject() {
      return {
        "counter-bubble__counter--highlighted": this.type === "highlighted",
        "counter-bubble__counter--outlined": this.type === "outlined",
        active: this.active
      };
    },
    humanizedCount() {
      if (this.raw) {
        return this.count.toString();
      }
      const formatter = new Intl.NumberFormat(getCanonicalLocale(), {
        notation: "compact",
        compactDisplay: "short"
      });
      return formatter.format(this.count);
    },
    originalCountAsTitleIfNeeded() {
      const countAsString = this.count.toString();
      if (this.raw || countAsString === this.humanizedCount) {
        return void 0;
      }
      return countAsString;
    }
  }
};
const _hoisted_1 = ["title"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["counter-bubble__counter", $options.counterClassObject]),
    title: $options.originalCountAsTitleIfNeeded
  }, toDisplayString($options.humanizedCount), 11, _hoisted_1);
}
const NcCounterBubble = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-f328a941"]]);
export {
  NcCounterBubble as N
};
//# sourceMappingURL=NcCounterBubble-6B_JNUUS.mjs.map
